import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineCustomersRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.customers, ['commercialName']),
  getCustomerPrincipalSalesRepresentative: async (customerId: string) => {
    const customer = await offlineCustomersRepository.getById(customerId);
    if (!customer) {
      throw new Error('customer not found for getting principal sales representative');
    }

    return customer.salesRepresentatives.find((sr) => sr.principal);
  },
};
